import React from 'react';
import { PostRepliesPreview } from '@components/Feed/Post/Comments/PostRepliesPreview';
import type { ChannelPost } from './ChannelPosts';

export function CommentPreviews({ post }: { post: ChannelPost }) {
  return (
    <PostRepliesPreview
      postId={post.id}
      postWebappUri={post.webappUri}
      postCommentCount={post.commentCount}
    />
  );
}
